import RoleService from "@/api/services/RoleService"
import Vue from "vue"

const state = () => ({
    roles: []
})

const getters = {
    ROLES: state => {
        return state.roles
    }
}

const mutations = {
    SET_ROLES: (state, payload) => {
        state.roles = payload
    }
}

const actions = {
    LOAD_ROLES: async ({ commit }) => {
        try {
            let { data, status } = await RoleService.get()
            if (status === 200) {
                commit("SET_ROLES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
